import { Helmet } from 'react-helmet';
import St from '../../screens/LoginScreen/LoginScreen.module.css';

const PreAuthContent = ({ children, pageTitle, formGreeting, formTitle }) => {
  return (
    <>
      <Helmet>
        <title>{pageTitle || 'Regure — Sign In'}</title>
        <link rel='preconnect' href='https://fonts.googleapis.com' />
        <link rel='preconnect' href='https://fonts.gstatic.com' crossOrigin='true' />
        <link
          href='https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700&family=Playfair+Display:ital,wght@0,400;0,500;0,600;1,400;1,500&display=swap'
          rel='stylesheet'
        />
      </Helmet>

      <div className={St.page}>
        {/* ════════════════ LEFT — STAGE ════════════════ */}
        <div className={St.stage}>
          <div className={St.stageBg} />
          <div className={St.stagePinstripe} />

          {/* Geometric accents */}
          <div className={`${St.geoAccent} ${St.geoRing}`} />
          <div className={`${St.geoAccent} ${St.geoRingInner}`} />
          <div className={`${St.geoAccent} ${St.geoLine}`} />
          <div className={`${St.geoAccent} ${St.geoDot} ${St.geoDot1}`} />
          <div className={`${St.geoAccent} ${St.geoDot} ${St.geoDot2}`} />
          <div className={`${St.geoAccent} ${St.geoDot} ${St.geoDot3}`} />

          <div className={St.stageContent}>
            {/* Top bar */}
            <div className={St.topBar}>
              <div className={St.logoGroup}>
                <img src='/Logo2.svg' alt='Regure' style={{ height: 40, filter: 'brightness(0) invert(1)', opacity: 0.92, display: 'block' }} />
              </div>
              <div className={St.versionPill}>Enterprise</div>
            </div>

            {/* Hero */}
            <div className={St.heroBlock}>
              <div className={St.heroOverline}>Insurance Intelligence Platform</div>
              <h1 className={St.heroHeadline}>
                Claims. Documents.
                <br />
                Workflows. Comms.
                <br />
                <span className={St.heroItalic}>One platform.</span>
              </h1>
              <p className={St.heroDesc}>
                Purpose-built for Managing General Agents and P&amp;C carriers. From first notice of loss to final settlement — every step automated, encrypted, and
                auditable.
              </p>
            </div>

            {/* Trust strip */}
            <div className={St.trustStrip}>
              {[
                { value: '99.9', highlight: '%', label: 'Uptime SLA' },
                { value: 'E2E', label: 'Encrypted' },
                { value: 'AES-256', label: 'At Rest' },
                { value: 'GDPR', label: 'Ready' },
              ].map((item, i) => (
                <div className={St.trustItem} key={i}>
                  <div className={St.trustValue}>
                    {item.value}
                    {item.highlight && <span className={St.trustHighlight}>{item.highlight}</span>}
                  </div>
                  <div className={St.trustLabel}>{item.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ════════════════ RIGHT — FORM ════════════════ */}
        <div className={St.formPanel}>
          <div className={St.formContainer}>
            <div className={St.formHeader}>
              <div className={St.formGreeting}>{formGreeting}</div>
              <h2 className={St.formTitle}>{formTitle}</h2>
            </div>
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default PreAuthContent;
